import React, { memo } from 'react';
import {
  DialogTitle,
  IconButton,
  Dialog as MaterialDialog,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBack from '@material-ui/icons/ArrowBack';
import * as Styled from './styled';

const Dialog = ({ children, onClose, onClickArrowBack, open, title }) => {
  const theme = useTheme();
  const largePhone = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <MaterialDialog fullScreen={!largePhone} fullWidth open={open} maxWidth="sm" onClose={onClose} scroll="body">
      <DialogTitle disableTypography style={{ textAlign: 'right', padding: '6px 12px 0' }}>
        <IconButton aria-label="close" onClick={onClose} data-id="closeDialogButton">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Styled.Content margintop={largePhone ? 0 : '32px'} data-id="dialog">
        <Styled.Header>
          {onClickArrowBack &&
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClickArrowBack}
              aria-label="close"
            >
              <ArrowBack style={{ width: '.7em' }} />
            </IconButton>
          }
          {title}
        </Styled.Header>
        <Styled.Main>
          {children}
        </Styled.Main>
      </Styled.Content>
    </MaterialDialog>
  );
};

export default memo(Dialog)
